import { createFileRoute } from "@tanstack/react-router";

import { OrganizaciskaStrukturaPage } from "../about_.organizaciska-struktura";

export const Route = createFileRoute("/en/about_/organizaciska-struktura")({
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=86400, stale-while-revalidate=604800",
	}),
	head: () => ({
		meta: [
			{ title: "Organizational Structure | Makedonijaturist AD" },
			{
				name: "description",
				content:
					"Organizational chart and structure of Makedonijaturist AD. Overview of company hierarchy and departments.",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en/about/organizaciska-struktura",
			},
		],
	}),
	component: OrganizaciskaStrukturaPage,
});
